
import { getInfoText } from '../components';

    function initBranches(blockEl) {
      const dataEl = blockEl.querySelector('.branches-gallery__data[type="application/json"]');
      let branches = [];
      if (dataEl) {
        try {
          branches = JSON.parse(dataEl.textContent || '[]');
        } catch (e) {
          console.warn('Failed to parse branches JSON', e);
        }
      }
     

      function selectGridItem(selected) {
        gridItems.forEach(item => {
            item.classList.remove('selected');
       });
       selected.classList.add('selected');

      }
  

      const detailsEl = blockEl.querySelector('.branch-details-card'); 
      const gridItems = blockEl.querySelectorAll(`.branch-button`);

      gridItems.forEach(item => {
        item.addEventListener('click', (e) => {
           if(item.classList.contains('selected')) return;
           selectGridItem(item);


          const id = item.getAttribute('data-branch-id');
          const branch = branches.find(b => String(b.id) === String(id));
          if (!branch) return;

          detailsEl.classList.add('is-updating');
          
            setTimeout(() => {


                //update details
                try {
                    const imageEl = detailsEl.querySelector('.branch-details-card__image');
                    imageEl.src = branch.image;
                    imageEl.alt = branch.title;

                    const titleEl = detailsEl.querySelector('.branch-info__title');
                    titleEl.textContent = branch.title;

                    const availabilityEl = detailsEl.querySelector('.branch-info__availability');
                    let infoText = getInfoText(branch);
                    availabilityEl.textContent = infoText;

                    const addressesList = detailsEl.querySelector('.branch-info__addresses');
                        addressesList.innerHTML = '';
                        const ul = document.createElement('ul');

                        if (Array.isArray(branch.addresses) && branch.addresses.length > 0) {
                            branch.addresses.forEach(addr => {
                                const li = document.createElement('li');
                                li.textContent = addr;
                                ul.appendChild(li);
                            });
                            addressesList.appendChild(ul);
                        }
                    
                    
                } catch (_error) {  
                    console.error('Failed to update details', _error);  
                }
                detailsEl.classList.remove('is-updating');

            }, 100);

          });
      });

    }
  
function init() {
  const blockEl = document.querySelector('[data-block="papa-lp-branches"]');
  if (blockEl) {
    initBranches(blockEl);
  }
}
  
 

  // Initialize on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-initialize on dynamic content load (e.g., AJAX)
  document.addEventListener('branches-gallery:init', init);
  